import { fromJS } from 'immutable';
import { setStateParamsType } from '@Constants/StateParamsConstants';

export const initialState = fromJS({});

// eslint-disable-next-line default-param-last
export default function stateParamsReducer(state = initialState, action) {
  if (action.type === setStateParamsType) {
    return fromJS(action.payload);
  }

  return state;
}
